// src/app/modules/BulkUpload/components/shared/SummaryCard.jsx

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, Typography } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  card: {
    height: '100%',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[4],
    },
  },
  primary: {
    backgroundColor: '#e3f2fd',
    '& $icon': {
      color: '#1976d2',
    },
    '& $value': {
      color: '#1976d2',
    },
  },
  success: {
    backgroundColor: '#e8f5e9',
    '& $icon': {
      color: '#388e3c',
    },
    '& $value': {
      color: '#388e3c',
    },
  },
  info: {
    backgroundColor: '#e1f5fe',
    '& $icon': {
      color: '#0288d1',
    },
    '& $value': {
      color: '#0288d1',
    },
  },
  warning: {
    backgroundColor: '#fff3e0',
    '& $icon': {
      color: '#f57c00',
    },
    '& $value': {
      color: '#f57c00',
    },
  },
  danger: {
    backgroundColor: '#ffebee',
    '& $icon': {
      color: '#d32f2f',
    },
    '& $value': {
      color: '#d32f2f',
    },
  },
  content: {
    textAlign: 'center',
    padding: theme.spacing(3),
  },
  icon: {
    fontSize: 40,
    marginBottom: theme.spacing(1),
  },
  value: {
    fontSize: 48,
    fontWeight: 700,
    lineHeight: 1,
    marginBottom: theme.spacing(1),
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
}));

const SummaryCard = ({ title, value, color = 'primary', icon }) => {
  const classes = useStyles();

  return (
    <Card className={clsx(classes.card, classes[color])}>
      <CardContent className={classes.content}>
        {icon && (
          <div>
            <i className={`fa ${icon} ${classes.icon}`}></i>
          </div>
        )}
        <Typography className={classes.value}>{value}</Typography>
        <Typography className={classes.title}>{title}</Typography>
      </CardContent>
    </Card>
  );
};

export default SummaryCard;